/**
 * Пропуск в комнату видеоинтервью — для заголовка запроса.
 *
 * Зачем. Опрос комнаты (`pollRoom`) — это query, а tRPC шлёт query методом
 * GET: всё, что лежит во входе, уезжает в строку адреса. Пропуск комнаты —
 * ключ к TURN, к сигналам связи и к приёму записи, живёт два часа, и раз в
 * секунду он попадал в логи прокси Railway и в историю браузера. Сервер умеет
 * принимать его заголовком `x-vi-session` (см. shared/videoInterview.ts), но
 * до 20.09.2026 клиент этот заголовок не слал ни разу — контракт был мёртв.
 *
 * Модульная переменная, а не React-состояние: заголовки собирает
 * `httpBatchLink` в main.tsx, вне дерева компонентов. Вкладка одна, комната в
 * ней одна — хранить больше одного пропуска незачем.
 */

let roomSessionToken: string | null = null;

/** Комната вошла: с этой минуты опрос ходит с пропуском в заголовке. */
export function setRoomSessionToken(token: string | null): void {
  roomSessionToken = token && token.trim() ? token : null;
}

/** Пропуск для заголовка; null — комнаты в этой вкладке сейчас нет. */
export function getRoomSessionToken(): string | null {
  return roomSessionToken;
}

/** Комната закрыта (выход, конец встречи, размонтирование). */
export function clearRoomSessionToken(): void {
  roomSessionToken = null;
}

/**
 * Сколько раз эта ВКЛАДКА входила в комнату. Растёт монотонно и живёт вне
 * React: перемонтирование комнаты его не сбрасывает.
 *
 * Зачем не состояние компонента (аудит 21.09.2026, третий заход). Номер входа
 * уходит во вход опроса и разводит сессии по разным ключам кэша. Пока счётчик
 * жил в `useState`, он обнулялся на каждом монтировании — и переход
 * «список встреч → комната A → назад → комната B» в пределах пяти минут давал
 * обеим комнатам один ключ `{afterId: 0, seq: 1}`. Ответ комнаты A отдавался
 * комнате B мгновенно, без запроса: курсор прыгал вперёд по чужим номерам
 * сообщений, настоящие сигналы новой комнаты уже не приходили, и связь просто
 * не устанавливалась. Модульная переменная этого не допускает.
 */
let roomJoinSeq = 0;

/** Следующий номер входа в комнату для этой вкладки. */
export function nextRoomJoinSeq(): number {
  roomJoinSeq += 1;
  return roomJoinSeq;
}
